import { render, staticRenderFns } from "./RolesDefault.vue?vue&type=template&id=adf2a060&scoped=true"
import script from "./RolesDefault.vue?vue&type=script&lang=js"
export * from "./RolesDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adf2a060",
  null
  
)

export default component.exports